module.exports = __webpack_public_path__ + "img/lib.c2dcc757.svg";